import React from 'react';
import type { PiV2VerificationSource } from '../../../patient-insurance/typesV2';
import { PatientProfileSectionCard } from '../PatientProfileSectionCard';

export interface PatientInsuranceVerificationSourcesProps {
  sources: PiV2VerificationSource[];
}

const COLS = 'grid grid-cols-[1.4fr_1.2fr_0.8fr_1.6fr] items-baseline gap-3';

/**
 * Verification Sources (spec §14) — the systems and evidence behind the current
 * insurance understanding. Supports trust and auditability without exposing raw
 * technical codes by default.
 */
export function PatientInsuranceVerificationSources({
  sources,
}: PatientInsuranceVerificationSourcesProps) {
  if (sources.length === 0) return null;

  return (
    <PatientProfileSectionCard icon="shield-check" title="Verification sources" accent="var(--ai-3)">
      <div
        className={`${COLS} pb-2 font-[var(--font-mono)] text-[9.5px] font-bold uppercase tracking-[0.1em] text-[var(--ink-4)]`}
      >
        <span>Source</span>
        <span>Last checked</span>
        <span>Result</span>
        <span>Details</span>
      </div>
      {sources.map((s) => (
        <div
          key={s.source}
          className={`${COLS} border-t border-[var(--cream-2)] py-2.5 text-[12.5px]`}
        >
          <span className="font-semibold text-[var(--ink-0)]">{s.source}</span>
          <span className="text-[var(--ink-2)]">{s.lastChecked}</span>
          <span className="text-[var(--ink-2)]">{s.result}</span>
          <span className="text-[var(--ink-3)]">{s.detail}</span>
        </div>
      ))}
    </PatientProfileSectionCard>
  );
}
